module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-route"
  }, [_c('router-link', {
    staticClass: "assignment-block-link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.assignment.image,
      "alt": _vm.assignment.title
    }
  }), _c('span', {
    staticClass: "assignment-icon",
    class: _vm.type_class
  }), _c('h2', [_vm._v(_vm._s(_vm.assignment.title))]), _c('p', [_vm._v(_vm._s(_vm.assignment.subtitle))])]), _c('div', {
    staticClass: "assignment__information"
  }, [_c('progress-bar', {
    attrs: {
      "assignment": _vm.assignment,
      "steps": _vm.steps,
      "progress": _vm.progress,
      "autolink": true,
      "mini": true
    }
  }), _c('span', {
    staticClass: "assignment__meta"
  }, [_c('span', {
    staticClass: "assignment__time tag"
  }, [_vm._v(_vm._s(_vm.assignment.time) + " minuten")]), _c('span', {
    staticClass: "assignment__group-size tag",
    class: _vm.groupSize.class,
    attrs: {
      "title": _vm.groupSize.title
    }
  }, [_vm._v(_vm._s(_vm.assignment.group_size))])])], 1), _c('primary-button', {
    attrs: {
      "link": _vm.link,
      "disabled": _vm.isDisabled
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503cf578","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/Route.vue
// module id = NC+L
// module chunks = 1